import styled from 'styled-components';

export const MediaRow = styled.div`
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 100%;
  max-height: 160px;
`;

export const MediaItem = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const VideoContainer = styled.div`
  /* padding: 3px; */
  box-sizing: border-box;
  max-width: 226px;
  min-width: 226px;
  position: relative;
  z-index: 1;
`;

export const MediaWithoutCaption = styled.div`
  left: 0;
  bottom: 0;
  height: 28px;
  position: absolute;
  width: 100%;
  z-index: 2;
`;

export const MediaTag = styled.video`
  flex: none;
  width: 100%;
  /* filter: blur(8px) brightness(70%); */
`;

export const ContainerMediaPlay = styled.div`
  left: 0;
  align-items: center;
  color: #fff;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
`;

export const MediaPlay = styled.div`
  background: rgba(0, 0, 0,.35);
  border-radius: 50%;
  align-items: center;
  color: #fff;
  display: flex;
  height: 50px;
  justify-content: center;
  position: relative;
  width: 50px;
  padding-top: 5px;
`;

export const ContainerVideoIcon = styled.span`
  left: 6px;
  bottom: 3px;
  position: absolute;
  z-ndex: 100;
  color: rgba(255, 255, 255,.9);
  font-size: 11px;
  line-height: 15px;
  height: 15px;
`;

export const VideoIconItem = styled.div`
  margin-right: 3px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
`;

export const MessageFooter = styled.div`
  bottom: 0;
  height: 28px;
  position: absolute;
  width: 100%;
  z-index: 2;
`;